export class TimeOff {
    public timeOffStart: Date
    public timeOffEnd: Date
    public toRemove: Boolean = false
    constructor (start: Date, end: Date) {
        this.timeOffStart = start;
        this.timeOffEnd = end;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/timeoff/timeoff.model.ts